import React from "react";
import { Helmet } from "react-helmet-async";
import Loader from "../../components/Loader";


const HelpDesk = () => {
  const [loading, setLoading] = React.useState(true);

  return (
  <React.Fragment>
    <Helmet title="Disputely Help Desk" />
    {loading && <Loader />}
    <iframe src="https://disputely.freshdesk.com" onLoad={() => setLoading(false)} style={{height: loading ? "0" : "100%", width: "100%"}} />
  </React.Fragment>
)};

export default HelpDesk;
